module.exports = __webpack_public_path__ + "img/cloud-minus.1ce1eed4.svg";